export default __webpack_public_path__ + "static/media/spectrophotometer-info-3.b3af388a.svg";